import { QuoteButton } from "@/components/QuoteButton";
import { useContent, useSiteImage } from "@/context/ContentContext";
import { Seo } from "@/lib/seo";

export default function APropos() {
  const { content } = useContent();
  const img = useSiteImage();
  const text = content?.apropos || "";
  return (
    <div data-testid="apropos-page" className="bg-white">
      <Seo title="À propos — Afro Regal" description="Afro Regal, traiteur événementiel créé en 2018 et structuré en SAS en 2023. Créateurs de beaux moments." />
      <section className="pb-24 pt-32 lg:pb-32 lg:pt-40">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:gap-16 lg:px-8">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <img src={img("apropos_hero")} alt="L'univers Afro Regal" className="aspect-[4/5] w-full object-cover" />
              <div className="mt-4 flex items-center justify-between border-t border-[#2C2C2C] pt-3 text-xs uppercase tracking-[0.25em] text-[#2C2C2C]/60">
                <span>Afro Regal</span><span>Depuis 2018</span>
              </div>
            </div>
          </div>
          <div className="fade-up lg:col-span-7">
            <p className="text-sm uppercase tracking-[0.3em] text-[#9A7B2C]">À propos</p>
            <h1 className="mt-5 border-b border-[#2C2C2C] pb-10 font-serif text-5xl font-500 leading-none text-[#2C2C2C] sm:text-6xl lg:text-8xl">Créateurs de beaux moments</h1>
            <p className="mt-10 whitespace-pre-wrap text-lg leading-relaxed text-[#2C2C2C]/80 first-letter:float-left first-letter:mr-3 first-letter:font-serif first-letter:text-7xl first-letter:leading-[0.8] first-letter:text-[#C9A84C]" data-testid="apropos-text">{text}</p>
            <div className="mt-12"><QuoteButton testId="apropos-quote" /></div>
          </div>
        </div>
      </section>
    </div>
  );
}
